"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _api = _interopRequireDefault(require("./services/api"));

var _authentication = _interopRequireDefault(require("./services/authentication"));

var _default = {
  API_TOKEN_REFRESH_FAIL: _authentication.default.API_TOKEN_REFRESH_FAIL,
  CONF_ID_REQUIRED: _authentication.default.CONF_ID_REQUIRED,
  INVALID_TOKEN: _authentication.default.INVALID_TOKEN,
  NO_CONF: _authentication.default.NO_CONF,
  NO_SDK_CONFIG: _authentication.default.NO_SDK_CONFIG,
  NO_STORED_TOKEN: _authentication.default.NO_STORED_TOKEN,
  authenticate: _authentication.default.authenticate,
  ssoLogin: _authentication.default.ssoLogin,
  ssoEnroll: _authentication.default.ssoEnroll,
  mfaAuth: _authentication.default.mfaAuth,
  logout: _authentication.default.logout,
  get: _api.default.get,
  getLogo: _api.default.getLogo,
  post: _api.default.post,
  v2: _api.default.v2,
  proxyAuthentication: _authentication.default.proxyAuthentication,
  refreshToken: _api.default.refreshToken,
  videoGuestLogin: _authentication.default.videoGuestLogin
};
exports.default = _default;
module.exports = exports.default;